module.exports = __webpack_public_path__ + "img/Calling.76750ce8.png";